import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { RootLayout } from '@/components/layout/RootLayout';
import { RouteFallback } from './RouteFallback';
import { RouteError } from './RouteError';
import { routes } from './routes';

// Code-split every page so the initial bundle stays small as the site grows.
const HomePage = lazy(() =>
  import('@/pages/HomePage').then((m) => ({ default: m.HomePage }))
);
const AboutPage = lazy(() =>
  import('@/pages/AboutPage').then((m) => ({ default: m.AboutPage }))
);
const MethodPage = lazy(() =>
  import('@/pages/MethodPage').then((m) => ({ default: m.MethodPage }))
);
const ServicesPage = lazy(() =>
  import('@/pages/ServicesPage').then((m) => ({ default: m.ServicesPage }))
);
const ProgramsPage = lazy(() =>
  import('@/pages/ProgramsPage').then((m) => ({ default: m.ProgramsPage }))
);
const GalleryPage = lazy(() =>
  import('@/pages/GalleryPage').then((m) => ({ default: m.GalleryPage }))
);
const ContactPage = lazy(() =>
  import('@/pages/ContactPage').then((m) => ({ default: m.ContactPage }))
);
const NotFoundPage = lazy(() =>
  import('@/pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage }))
);

/** Wraps a lazy page in a Suspense fallback. */
function page(element: React.ReactNode) {
  return <Suspense fallback={<RouteFallback />}>{element}</Suspense>;
}

export const router = createBrowserRouter([
  {
    path: routes.home,
    element: <RootLayout />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: page(<HomePage />) },
      { path: routes.about, element: page(<AboutPage />) },
      { path: routes.method, element: page(<MethodPage />) },
      { path: routes.services, element: page(<ServicesPage />) },
      { path: routes.programs, element: page(<ProgramsPage />) },
      { path: routes.gallery, element: page(<GalleryPage />) },
      { path: routes.contact, element: page(<ContactPage />) },
      { path: '*', element: page(<NotFoundPage />) },
    ],
  },
]);
